document.addEventListener('DOMContentLoaded', (event) => {
    
    $('.slider__main .slider-wrapper').slick({
        speed: 500,
        autoplay: true,
        autoplaySpeed: 4000,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        nextArrow: $('.slider__main .slider-next-btn'),
        prevArrow: $('.slider__main .slider-prev-btn')
    }); 
    
    $('.slider__secondary .slider-wrapper').slick({
        speed: 500,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        nextArrow: $('.slider__secondary .slider-next-btn'),
        prevArrow: $('.slider__secondary .slider-prev-btn')
    }); 

    $('.slider__secondary .slider-wrapper').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        
        $('.slider-pagination .page-status .current').text(nextSlide + 1);

    });

    $(".job-filters a").on("click", function (e) {

        e.preventDefault(); 

        $(".job-filters a").removeClass("active"); 
        
        $(this).addClass("active");

        var filter_val = $(this).attr("data-filter");

        $(".no-job-opening").text(""); 
        
        $(".no-job-opening").css("display", "none"); 

        $(".job-listing").slideUp("fast", function () {

            $(".job-listing .row-item").css("display", "none").removeClass("last-item");
            
            if(filter_val == "all") {

                $(".job-listing .row-item").css("display", "block");

            }

            else {

                $('.job-listing .row-item[data-category="' + filter_val + '"]').css("display", "block");

            } 

            $(".job-listing").slideDown("fast", function () {

                if($(".job-listing .row-item:visible").length == 0) {

                    $(".no-job-opening").text("No job opening for " + filter_val); 
                    
                    $(".no-job-opening").css("display", "block");

                }
                
                else {
                    
                    $(".job-listing .row-item:visible:last").addClass("last-item");

                }
            });

        });

    }); 

    $(".job-filters .select-job-filter select").on("change", function () {

        var filter_val = $(this).val();

        $('.job-filters a[data-filter="' + filter_val + '"]').trigger("click");

    });

});